export const subSkeletonSytles = {
  container: {
    width: {
      mobile: "85vw",
      tablet: "90vw",
      laptop: "85vw",
    },
    height: {
      mobile: "15.313rem",
      tablet: "11.8rem",
      laptop: "17.8rem",
      desktop: "20.25rem",
    },
    maxWidth: {
      laptop: "33.813rem",
    },
  },
  height: {
    height: "90%",
  },
};
